import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const NotFound: React.FC = () => {
  return (
    <>
      <Header />

      <section className="d-flex align-items-center justify-content-center vh-100 bg-light">
        <div className="text-center">
          <h1 className="display-4 fw-bold text-danger">404</h1>
          <p className="lead mb-3">Oops! The page you're looking for doesn't exist.</p>
          <p className="text-muted mb-4">It may have been moved or deleted.</p>
          <Link to="/" className="btn btn-primary">
            ← Back to Homepage
          </Link>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default NotFound;
